import { render, staticRenderFns } from "./Site_content-2.vue?vue&type=template&id=01f0ebe4&scoped=true&"
import script from "./Site_content-2.vue?vue&type=script&lang=js&"
export * from "./Site_content-2.vue?vue&type=script&lang=js&"
import style0 from "./Site_content-2.vue?vue&type=style&index=0&id=01f0ebe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0ebe4",
  null
  
)

export default component.exports